var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("DetailButton", {
        attrs: {
          disabled: false,
          imageSrc: "/static/cancel.svg",
          title: "SERVIÇO NÃO REALIZADO"
        },
        on: {
          clicked: function($event) {
            return _vm.showDialog()
          }
        }
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "min-width": "320", "max-width": "500" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "title" }, [
                _c("span", [
                  _vm._v("Deseja marcar a limpeza como não realizada?")
                ])
              ]),
              _vm._v(" "),
              _c("v-divider", { attrs: { light: "" } }),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("v-spacer"),
                  _vm._v("\n        Limpeza da(o)\n        "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm._f("fullName")(this.order.customer.account))
                    )
                  ]),
                  _vm._v(" com o\n        profissional\n        "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm._f("fullName")(this.order.professional.account)
                      )
                    )
                  ]),
                  _vm._v(" no\n        dia\n        "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatDate")(
                          this.order.schedule_event.starts_at,
                          "DD/MM/Y HH:mm"
                        )
                      ) + "h\n        "
                    )
                  ]),
                  _vm._v("\n        com\n        "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm._f("durationInHous")(
                          this.order.schedule_event.duration
                        )
                      )
                    )
                  ]),
                  _vm._v("\n        de duração\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider", { attrs: { light: "" } }),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _vm.setNotProvidedResult
                        ? _c(
                            "v-layout",
                            { staticClass: "icon-wallet", attrs: { row: "" } },
                            [
                              _c("v-flex", { attrs: { md3: "" } }, [
                                _c("img", {
                                  attrs: { src: _vm.setNotProvidedImage }
                                })
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass:
                                    "message-set-not-provided-result",
                                  attrs: { md9: "" }
                                },
                                [
                                  _c("p", [
                                    _vm._v(_vm._s(_vm.setNotProvidedMessage))
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { "xs-6": "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "modal-button",
                                      attrs: { color: "primary", outlined: "" },
                                      on: {
                                        click: function($event) {
                                          _vm.dialog = false
                                        }
                                      }
                                    },
                                    [_vm._v("Não")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { "xs-6": "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "modal-button",
                                      attrs: {
                                        loading: _vm.preloader,
                                        color: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.setOrderServicesNotProvided()
                                        }
                                      }
                                    },
                                    [_vm._v("SIM, A LIMPEZA NÃO FOI REALIZADA")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7dba97eb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dba97eb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Orders/ShowOrder/SetServiceNotProvided.vue
// module id = null
// module chunks = 